import React, { useState, useCallback } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { GetFormatedDateWithTime } from '../../../../../common/Utils'
import { createStore } from 'devextreme-aspnet-data-nojquery';
import TransactionSearchFormResult from "../maintabs/transaction/TransactionSearchFormResult";
import TransactionSearchForm from "../maintabs/transaction/TransactionSearchForm";
const EDITransaction = (props) => {
    const orderStatus = '0';
    const getDataUrl = "wm/TransactionManagement/GetTransactionHeader";
    const [dataSource, setDataSource] = useState(null);
    const [pageTitle, setPageTitle] = useState('Transactions (EDI-Trans)');
    const [selectedRowId, setSelectedRowId] = useState(null);
    const [refreshKey, setRefreshKey] = useState(0);
    var accessToken = props.oidc.user.access_token;
    const GetGridData = (accessToken, url, formFields) => {
        const resultData = createStore({
            key: 'rowid',
            loadParams:
            {
                CustomerId: function () {
                    return formFields.R_CUSTOMER;
                },
                Recordtype: function () {
                    return 'U';
                },
                Transactiontype: function () {
                    return 'EDI';
                },
                TransactionDateFrom: function () {
                    return GetFormatedDateWithTime(formFields.TransactionDateFrom);
                },
                CarrierId: function () {
                    return formFields.R_CARRIER;
                },
                TransactiondateTo: function () {
                    return GetFormatedDateWithTime(formFields.TransactionDateTo);
                },
                TransactiondateTo: function () {
                    return GetFormatedDateWithTime(formFields.TransactionDateTo);
                },
                CarrierName: function () {
                    return formFields.CarrierName;
                },
                DeliveryDateFrom: function () {
                    return GetFormatedDateWithTime(formFields.DeliveryDateFrom);
                },
                Transactionnumber: function () {
                    return formFields.TRANSACTIONNUMBER;
                },
                DeliverydateTo: function () {
                    return GetFormatedDateWithTime(formFields.DeliveryDateTo);
                },  transStatus: function () {
                    return 2;
                },
            },
            loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                };
            },
        });
        return resultData;
    };
    const searchData = (formFields) => {
        var resultData = GetGridData(accessToken, getDataUrl, formFields);
        setDataSource(resultData);
    };
    const handleRowSelected = useCallback((rowId) => setSelectedRowId(rowId), []);
    return (
        <div>
            <div className="row">
                <div className="col-md-12 main-page">
                    <div id="accordion" >
                        <TransactionSearchForm pageTitle={pageTitle} searchData={searchData} isEdiTab={true} selectedRowId={selectedRowId} onGridRefresh={() => { setSelectedRowId(null); setRefreshKey(prev => prev + 1); }} onProfileApply={props.onProfileApply} />
                        <TransactionSearchFormResult key={refreshKey} data={dataSource} gridKey={"5FECE0B3-F2DF-4EAA-89C5-242CB2D8B4F1"} onRowSelected={handleRowSelected} />
                    </div>
                </div>
            </div>
        </div>
    );
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(EDITransaction);